import React, { createContext, useContext } from 'react';
export const DEFAULT_CONFIG = {
    language: 'en',
    accountLanguage: 'en',
    regionalFormat: 'en'
};
export const ConfigContext = createContext(null);
export function ConfigContextProvider({ value: configInput, children }) {
    const config = {
        ...configInput,
        language: configInput.language ?? DEFAULT_CONFIG.language,
        accountLanguage: configInput.accountLanguage ?? DEFAULT_CONFIG.accountLanguage,
        regionalFormat: configInput.regionalFormat ?? DEFAULT_CONFIG.regionalFormat
    };
    return React.createElement(ConfigContext.Provider, {
        value: config
    }, children);
}
export function useConfig() {
    const context = useContext(ConfigContext);
    if (context === undefined) {
        throw new Error('useConfig must be used within a ConfigContext.Provider');
    }
    return context || DEFAULT_CONFIG;
}

//# sourceMappingURL=config-context.js.map